export const UwUid = () => new Date().getTime() 
                             + "_" 
                             + Math.random()
                                   .toString(16);